import { createAction } from 'app-components/flux/core/actionHelpers';

export const authLogin = createAction(
  'AUTH_LOGIN',
  (payload) => payload,
  (payload, meta) => meta,
);
export const authLogout = createAction(
  'AUTH_LOGOUT',
  (payload) => payload,
  (payload, meta) => meta,
);

export const getOAuthToken = createAction(
  'AUTH_GET_OAUTH_TOKEN',
  (payload) => payload,
  (payload, meta) => meta,
);
export const getOAuthTokenSuccess = createAction('AUTH_GET_OAUTH_TOKEN_SUCCESS');
export const getOAuthTokenFailure = createAction('AUTH_GET_OAUTH_TOKEN_FAILURE');

export const exchangeRefreshToken = createAction(
  'EXCHANGE_REFRESH_TOKEN',
  (payload) => payload,
  (payload, meta) => meta,
);
export const exchangeRefreshTokenSuccess = createAction(
  'EXCHANGE_REFRESH_TOKEN_SUCCESS',
  (payload) => payload,
  (payload, meta) => meta,
);
export const exchangeRefreshTokenFailure = createAction(
  'EXCHANGE_REFRESH_TOKEN_FAILURE',
  (payload) => payload,
  (payload, meta) => meta,
);

export const updateAuth = createAction('AUTH_UPDATE');

export const invalidateAccessToken = createAction(
  'INVALIDATE_ACCESS_TOKEN',
  (payload) => payload,
  (payload, meta) => meta,
);
export const invalidateRefreshToken = createAction(
  'INVALIDATE_REFRESH_TOKEN',
  (payload) => payload,
  (payload, meta) => meta,
);

export const authSelectDataset = createAction('AUTH_SELECT_DATASET');
export const authSelectDatasetAuto = createAction('AUTH_SELECT_DATASET_AUTO');

export const authUpdated = createAction(
  'AUTH_UPDATED',
  (payload) => payload,
  (payload, meta) => meta,
);
export const persistAuthSession = createAction('AUTH_PERSIST_AUTH_SESSION');
